import { getYear } from 'date-fns/getYear'
import { startOfYear } from 'date-fns/startOfYear'
import { endOfYear } from 'date-fns/endOfYear'
import { isLeapYear } from 'date-fns/isLeapYear'
import { differenceInDays } from 'date-fns/differenceInDays'
import { addYears } from 'date-fns/addYears'

import { NORMAL_YEAR_DAYS, LEAP_YEAR_DAYS } from '../constants/rule'

function getUpToDays(dateToCalc, dateToCompare) {
  return differenceInDays(dateToCompare, dateToCalc) + 1
}

export function calcCommission(loanBalance, dateToCalc, tradeDate, ratePerYear) {
  if (getYear(tradeDate) > getYear(dateToCalc)) {
    // 当年分
    const endOfYearDate = endOfYear(dateToCalc)
    const ratePerDay1 = isLeapYear(dateToCalc) ? ratePerYear / LEAP_YEAR_DAYS : ratePerYear / NORMAL_YEAR_DAYS // 日利
    const upToDays1 = getUpToDays(dateToCalc, endOfYearDate)

    // 次年分
    const startOfYearDate = startOfYear(addYears(dateToCalc, 1))
    const ratePerDay2 = isLeapYear(tradeDate) ? ratePerYear / LEAP_YEAR_DAYS : ratePerYear / NORMAL_YEAR_DAYS // 日利
    const upToDays2 = getUpToDays(startOfYearDate, tradeDate)

    if (ratePerDay1 === ratePerDay2) {
      const commission1 = (loanBalance * ratePerDay1 * upToDays1) / 100
      const commission2 = (loanBalance * ratePerDay2 * upToDays2) / 100
      return Math.floor(commission1 + commission2)
    } else {
      const commission1 = Math.floor((loanBalance * ratePerDay1 * upToDays1) / 100)
      const commission2 = Math.floor((loanBalance * ratePerDay2 * upToDays2) / 100)
      return commission1 + commission2
    }
  }

  const ratePerDay = isLeapYear(dateToCalc) ? ratePerYear / LEAP_YEAR_DAYS : ratePerYear / NORMAL_YEAR_DAYS // 日利
  const upToDays = getUpToDays(dateToCalc, tradeDate)
  return Math.floor((loanBalance * ratePerDay * upToDays) / 100)
}
